import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import brandPortalMyShopSettings from "@faire/web-api/routes/brand-portal/my-shop/settings";
import React from "react";
import { InternationalOrderSettings } from "./instantAnswersComponents/orders/InternationalOrderSettingsIA";
export var internationalOrderSettings = function internationalOrderSettings(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return INTERNATIONAL_ORDER_SETTINGS_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return INTERNATIONAL_ORDER_SETTINGS_DESCRIPTION();
    }
  };
};
var INTERNATIONAL_ORDER_SETTINGS_TITLE = function INTERNATIONAL_ORDER_SETTINGS_TITLE(strictLocalize) {
  return strictLocalize({
    id: "BZ0r0L",
    defaultMessage: [{
      "type": 0,
      "value": "International order settings"
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return {
    label: strictLocalize({
      id: "bt72CH",
      defaultMessage: "View shop settings"
    }),
    getLink: function getLink() {
      return brandPortalMyShopSettings();
    }
  };
};
var INTERNATIONAL_ORDER_SETTINGS_DESCRIPTION = function INTERNATIONAL_ORDER_SETTINGS_DESCRIPTION() {
  return /*#__PURE__*/React.createElement(InternationalOrderSettings, null);
};